import React, { useEffect } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

const MediaLightbox = ({ media, currentIndex, onClose, onNavigate }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') onNavigate('prev');
      if (e.key === 'ArrowRight') onNavigate('next');
    };
    
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [onClose, onNavigate]);

  if (!media || media.length === 0) return null;
  
  const currentItem = media[currentIndex];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm">
      <button 
        onClick={onClose}
        className="absolute top-6 right-6 p-2 text-white/70 hover:text-white bg-black/50 hover:bg-black/80 rounded-full transition-all"
      >
        <X size={24} />
      </button>

      {media.length > 1 && (
        <>
          <button 
            onClick={() => onNavigate('prev')}
            className="absolute left-6 top-1/2 -translate-y-1/2 p-3 text-white/70 hover:text-white bg-black/50 hover:bg-black/80 rounded-full transition-all"
          >
            <ChevronLeft size={32} />
          </button>
          
          <button 
            onClick={() => onNavigate('next')}
            className="absolute right-6 top-1/2 -translate-y-1/2 p-3 text-white/70 hover:text-white bg-black/50 hover:bg-black/80 rounded-full transition-all"
          >
            <ChevronRight size={32} />
          </button>
        </>
      )}

      <div className="max-w-5xl max-h-[85vh] w-full h-full p-4 flex items-center justify-center">
        {currentItem.kind === 'video' ? (
          <video 
            src={currentItem.publicUrl} 
            controls 
            autoPlay 
            className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
          />
        ) : (
          <img 
            src={currentItem.fullUrl || currentItem.publicUrl} 
            alt={currentItem.caption || 'Trip media'} 
            className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
          />
        )}
      </div>
      
      {currentItem.caption && (
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 max-w-2xl w-full px-6">
          <div className="bg-black/60 backdrop-blur-md text-white text-center p-4 rounded-2xl">
            <p className="text-sm md:text-base">{currentItem.caption}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MediaLightbox;
